import { Fragment, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import CircularProgress from '@mui/material/CircularProgress';
import CopyrightIcon from '@mui/icons-material/Copyright';
import { fetchData, postData } from '../../../apiService';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import Select from 'react-select';


const SubContractDetail = () => {
    const history = useHistory();
    const { isAuthenticated, companyId, userId, logout, token } = useAuth();
    const [isLoading, setIsLoading] = useState(false);

    // Logout if token is expired
    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
    }, [isAuthenticated, token, logout]);

    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");

    const [formData, setFormData] = useState({
        CompanyId: companyId,
        Name: '',
        ContactNumber: '',
        StateId: '',
        PurchaseId: '',
        CreatedBy: userId,
        CreatedDate: new Date().toISOString(),
    });

 

    const submitData = async () => {

        setIsLoading(true);

        try {
            // Fetch existing data
            const SubContacters = await fetchData('SubContractAPI', `/${companyId}`, token);
            console.log('Existing SubContact:', SubContacters);

            if (
                SubContacters.response_data &&
                Array.isArray(SubContacters.response_data) &&
                SubContacters.response_data.some(
                    (item) => item.Name === formData.Name
                )
            ) {
                setErrorMessage('SubContacter with the same Name already exists.');
                setIsLoading(false);
                return;
            }

            if (
                SubContacters.response_data &&
                Array.isArray(SubContacters.response_data) &&
                SubContacters.response_data.some(
                    (item) => item.ContactNumber === formData.ContactNumber
                )
            ) {
                setErrorMessage('SubContacter with the same Contact Number already exists.');
                setIsLoading(false);
                return;
            }
           
           
            // Submit data

            setFormData(prevData => ({
                ...prevData,
                CreatedBy: userId,
                CompanyId: companyId
              
            }));

            const response = await postData('SubContractAPI', formData, token);
            console.log('Data Created success:', response);

            history.push('/SubContractIndex');
        } catch (error) {
            console.error('Error:', error);
            alert('An error occurred. Please try again.');
        }
    };

    const [StateOptions, setstateOptions] = useState([]);
    const [selectedstateType, setSelectedstateType] = useState("");

    const fetchStates = async () => {
        try {

            const response = await fetchData('SubContractAPI', `/States/${companyId}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(state => ({
                    value: state.Id,
                    label: state.Name
                }));
                setstateOptions(options);
            }
        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };
    const handlestateChange = (selectedOption) => {
        setSelectedstateType(selectedOption);
        setFormData(prevData => ({
            ...prevData,
            StateId: selectedOption ? selectedOption.value : '',
            CreatedBy: userId,
            CompanyId: companyId,
        }));
    };

    useEffect(() => {
        fetchStates();
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevData => ({  
            ...prevData,
            [name]: value
        }));
    };
    return (
        <Fragment>
            <div className="w-full max-w-sm container mt-2 mx-auto" style={{ minWidth: '101%' }}>

                <div className='w-full mb-2 flex' style={{ marginTop: '-20px' }}>
                    <h6 className='block uppercase tracking-wide text-black productHead flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>SubContract Create</h6>
                    <Button
                        style={{
                            background: 'linear-gradient(to right,rgb(94, 179, 138),rgb(98, 150, 61))',
                            color: 'white',
                            textTransform: 'none',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                            maxHeight: '30px',
                            marginLeft: '15px',
                        }}
                        onClick={submitData}
                        disabled={isLoading}
                    >
                        {isLoading ? <CircularProgress size={24} color="inherit" /> : <span>Save</span>}
                    </Button>

                    <Button
                        component={Link}
                        to="/SubContractIndex"
                        className="linkcolor"
                        style={{
                            background: 'linear-gradient(to right,rgb(162, 31, 31),rgb(223, 91, 70))',
                            color: 'white',
                            textTransform: 'none',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                            maxHeight: '30px',
                            marginLeft: '15px',
                        }}
                    >
                        Cancel
                    </Button>

                </div>

                {errorMessage && <p className="text-red-500">{errorMessage}</p>}
                {successMessage && <p className="text-green-500">{successMessage}</p>}

                <div className="watermark">
                    <CopyrightIcon /><b style={{ fontFamily: 'Script Bold Italic' }}>EFFTABS SOLUTIONS LLP</b>
                </div>

                <div className="w-full flex flex-wrap">
                    <div className="w-full" style={{ padding: '7px', borderRadius: '10px' }}>
                        <div className="w-full mb-3 flex" >

                          

                            <div className="w-3/5 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs mb-2">
                                    Name<span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.Name}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="Name"
                                    name='Name'
                                    onClick={(e) => e.target.select()}
                                    style={{ height: '32px' }}
                                />
                            </div>

                      
                      

                       
                            <div className="w-1/5 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs mb-2">
                                    Contact No.<span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.ContactNumber}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="ContactNumber"
                                    name='ContactNumber'
                                    onClick={(e) => e.target.select()}
                                    style={{ height: '32px' }}
                                />
                            </div>


                            <div className="w-2/5 mr-2">

                                <label className="block uppercase tracking-wide text-black text-xs mb-2">
                                    State<span className="text-red-500">*</span>
                                </label>

                                <Select
                                    value={selectedstateType}
                                    onChange={handlestateChange}
                                    options={StateOptions}
                                    placeholder="State"
                                    isSearchable
                                    styles={{
                                        control: (base) => ({
                                            ...base,
                                            height: '32px',         // Adjust height
                                            minHeight: '32px',      // Ensure it doesn't shrink below this
                                            fontSize: '14px',       // Adjust font size
                                        }),
                                        input: (base) => ({
                                            ...base,
                                            fontSize: '14px',       // Adjust font size for input text
                                        }),
                                        singleValue: (base) => ({
                                            ...base,
                                            fontSize: '14px',       // Adjust font size for selected value
                                        }),
                                    }}
                                />
                            </div>
                         
                        </div>
                    </div>
                </div>


            </div >
        </Fragment >
    );
};

export default SubContractDetail;

